
    import '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-agent-tbox-demo-agent-tbox"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.zh-CN.md?type=demo')
};